exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.segment-span {\n  display: inline-block;\n  padding: 1px 5px;\n  margin: 1px;\n\n  background-color: #f4f4f5;\n\n  border-radius: 2px;\n  border-color: #e9e9eb;\n  border-width: 1px;\n  border-style: solid;\n\n  color: #909399;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f1f0f10","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketWidgetSegment.vue
// module id = 829
// module chunks = 75